import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'
import { Provider } from 'react-redux'
import store from './redux/store'
import register from './registerServiceWorker'
import { ConnectedRouter } from 'react-router-redux'
import routerHistory from './redux/routerHistory.js'
import './assets/css/style.css'
import './assets/css/user_style.css'
import './assets/vendor/css/common.css'
import './assets/vendor/font-awesome-4.7.0/css/font-awesome.min.css'
import './index.css'
ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={routerHistory}>
            <App />
        </ConnectedRouter>
    </Provider>

    , document.getElementById('root'))
register()



// WEBPACK FOOTER //
// ./src/index.js